module.exports = __webpack_public_path__ + "static/media/people-star-fill-primary.7b6c5045.svg";